/* talk·point — Autoplay anhalten, sobald ein Finger den Slider fuehrt.

   Horizons <slideshow-component> bindet ihren Drag-Pfad an mousedown
   (assets/slideshow.js). Auf iOS feuert mousedown nur beim Tippen, nie beim
   Wischen: die Komponente sieht die Geste nicht, pausiert das Autoplay nicht
   und laesst scroll-snap an. Der naechste Autoplay-Tick faellt dann mitten in
   den laufenden Scroll — und auf dem letzten Slide haengt der Endlos-Pfad dabei
   einen Slide im DOM um, also genau dort, wo der Finger gerade durchfaehrt.
   Gemessen auf iOS 18.6: Richtungsumkehr und Sprung im selben Wisch
   (docs/perf/hero-slider-ios-quickeln.md).

   Wer selbst wischt, steuert selbst: das Autoplay kommt danach nicht zurueck.
   Ein automatischer Weitersprung nach eigener Auswahl wird als Fehler gelesen —
   und jeder Nachlauf-Timer waere nur ein neues Kollisionsfenster. */
(function () {
  if (window.__tpSliderTouch) return;
  window.__tpSliderTouch = true;

  function wache(slideshow) {
    var track = slideshow.querySelector('slideshow-slides');
    if (!track || track.__tpTouchGuard) return;
    track.__tpTouchGuard = true;

    function anhalten() {
      // pause() setzt das paused-Attribut und stoppt das Intervall. resume()
      // nimmt wegen dieses Attributs nicht wieder auf — genau so gewollt.
      if (typeof slideshow.pause === 'function') slideshow.pause();
    }

    track.addEventListener('touchstart', anhalten, { passive: true });
    // Stift und andere Nicht-Maus-Zeiger sind derselbe Fall. Die Maus bleibt
    // beim Horizon-Verhalten: mouseenter pausiert, mouseleave nimmt wieder auf.
    track.addEventListener(
      'pointerdown',
      function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') anhalten();
      },
      { passive: true }
    );
  }

  function alle(wurzel) {
    var gefunden = (wurzel || document).querySelectorAll('slideshow-component[autoplay]');
    for (var i = 0; i < gefunden.length; i++) wache(gefunden[i]);
  }

  function start() {
    alle(document);
    // Der Theme-Editor rendert Sections neu — die frischen Tracks brauchen die Wache auch.
    document.addEventListener('shopify:section:load', function (event) {
      alle(event.target);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
